import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'select-language',
  template: `
             <button type="button" class="btn btn-outline-secondary btn-sm" (click)="useLanguage('en')">English</button>
             &nbsp;
             <button type="button" class="btn btn-outline-secondary btn-sm" (click)="useLanguage('es')">Español</button>
             `,
})
export class SelectLanguageComponent {

  constructor(private translate: TranslateService) {
    translate.setDefaultLang('en');
  }

  useLanguage(language: string) {
    this.translate.use(language);
  }

}
